<script setup lang="ts">
export type Props = {
  strokeWidth?: number
  strokeColor?: string
}

withDefaults(defineProps<Props>(), {
  strokeWidth: 1,
  strokeColor: '#F4B88C',
})
</script>

<template>
  <svg
    class="h-7 w-7 transition-transform duration-200"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M9 18L15 12L9 6"
      :stroke="strokeColor"
      :stroke-width="Math.max(2, strokeWidth * 0.8)"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
